import { Grid, Paper, Theme, useMediaQuery } from "@mui/material"
import { MyReferralTableContent } from "."
import useGlobalStore from "../../stores/global"
import { CompactTable, StyledPaper, TableLoadingSkeleton, TablePagination } from "../commons"
import MyReferralTableContentMobile from "./MyReferralsTableContentMobile"
import { constructReferralTable, tableHeadersReferral } from "./table"
import { useState } from "react"

const MyReferralTable = () => {

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))
  const referrals = useGlobalStore((state) => state.referralsData)
  const updateReferrals = useGlobalStore((state) => state.getReferralData)
  const tableRows = referrals.sort((a, b) => new Date(b.date).valueOf() - new Date(a.date).valueOf()).filter((referral) => referral.referee.toLowerCase())
  const tableReferralData = constructReferralTable(tableRows)
  const [isDataLoading, setIsDataLoading] = useState(false)


  const tablePagination = async (numberOfItemsToDisplay: number, offset: number) => {
    setIsDataLoading(true)
    await updateReferrals(offset, numberOfItemsToDisplay)
    setIsDataLoading(false)
  }
  const tableContent = isDataLoading ? <TableLoadingSkeleton tableHeaders={tableHeadersReferral ?? []} /> : tableReferralData

  return (
    <Grid item container>
      <StyledPaper color='primary' transparent sx={{
        // backgroundColor: '#283D3E', 
        minWidth: '100%',
        width: '100%',
        borderRadius: 0,
        padding: '0px', //to show border
      }}>
        <Grid container flexDirection={'column'} gap={0}>
          <Paper sx={{
            paddingTop: '1rem',
            width: '100%'
          }}>
            <Grid container alignItems={'center'} gap={2}
              justifyContent={'flex-start'}>
              {
                isMobile ? <MyReferralTableContentMobile /> : <MyReferralTableContent />
              }
              <Grid item sx={{ overflowX: 'auto', marginTop: 1.5, width: '100%' }}>
                <CompactTable tableHeader={tableHeadersReferral} tableContent={tableContent} />
                <TablePagination dataLength={tableRows.length} callback={tablePagination} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </StyledPaper>
    </Grid >
  )
}

export default MyReferralTable